/**
 * Gestione caricamento in cascata dei form per indirizzi
 */

export default $ => {
    $.AddressingWidget({route: 'ajax_address_form_component'});
};



// WEBPACK FOOTER //
// ./assets/js/component/addressing.js